/* AUTAVEX — додаткові набори фото.
   Ключ без префікса = Ромб; '1|N' = Сота; '2|N' = Крапля. */
(function(){
var S=window.AV_KANT_SETS=window.AV_KANT_SETS||{};
var CANT={0:'02_chornyi',1:'03_svitlosiryi',2:'04_siryi',3:'01_chervonyi',4:'11_syniy',5:'12_temnosyniy',
 6:'08_khaki',7:'14_korychnevyi',8:'16_bezhevyi',9:'17_slonovakistka',10:'18_bordovyi',11:'09_fioletovyi',
 12:'13_rozovyi',13:'07_zelenyi',14:'05_zhovtyi',15:'06_oranzhevyi',16:'15_bilyi',17:'10_holubyi'};
function build(prefix,ver){var o={};for(var k in CANT)o[k]=prefix+CANT[k]+'.jpg'+ver;return o}

/* —— РОМБ —— */
var Gp='AUTAVEX-osnova-siryi_kant-';
S[1]=build(Gp,'?v=1786205196');
S[1][8]=Gp+'16_bezhevyi.jpg?v=1786205195';
S[1][0]=Gp+'02_chornyi.jpg?v=1786205195';
S[1][13]=Gp+'07_zelenyi.jpg?v=1786205195';
S[6]=build('AUTAVEX-osnova-syniy_kant-','?v=1786204622');
var P='AUTAVEX-osnova-khaki_kant-',a='?v=1786191651',b='?v=1786191652',c='?v=1786191683',d='?v=1786191684';
S[8]={0:P+'02_chornyi.jpg'+b,1:P+'03_svitlosiryi.jpg'+b,2:P+'04_siryi.jpg'+a,3:P+'01_chervonyi.jpg'+b,
 4:P+'11_syniy.jpg'+c,5:P+'12_temnosyniy.jpg'+c,6:P+'08_khaki.jpg'+a,7:P+'14_korychnevyi.jpg'+c,
 8:P+'16_bezhevyi.jpg'+c,9:P+'17_slonovakistka.jpg'+c,10:P+'18_bordovyi.jpg'+d,11:P+'09_fioletovyi.jpg'+c,
 12:P+'13_rozovyi.jpg'+c,13:P+'07_zelenyi.jpg'+a,14:P+'05_zhovtyi.jpg'+a,15:P+'06_oranzhevyi.jpg'+b,
 16:P+'15_bilyi.jpg'+c,17:P+'10_holubyi.jpg'+c};
S[0]=S[0]||{};
S[0][8]='AUTAVEX-osnova-chornyi_kant-16_bezhevyi.jpg?v=1786204877';
S[0][9]='AUTAVEX-osnova-chornyi_kant-17_slonovakistka.jpg?v=1786204876';

/* —— СОТА: чорна —— */
var z='AUTAVEX-osnova-chorna-sota_kant-',W='.jpg?v=1786209417';
S['1|0']={0:z+'02_chornyi_6b19629f-5491-4369-8845-e5699101ded9'+W,1:z+'03_svitlosiryi_637b9e58-a41f-4d19-a2d2-4e5a5579aadb'+W,
 2:z+'04_siryi_674b1e8b-fd05-41ed-afe0-4856827cffea'+W,3:z+'01_chervonyi_f3c30f9b-1202-4c6d-ab78-968ae2b24c87'+W,
 4:z+'11_syniy_8f2b509a-f641-4d4b-8992-2598fe0f4a08'+W,5:z+'12_temnosyniy_651fa3ed-6bbb-4003-930f-f6be26100ac3'+W,
 6:z+'08_khaki_7f5bcccb-4879-4afc-af84-dac7f4f37645'+W,7:z+'14_korychnevyi_71c7ccb8-a780-44a3-aaee-2512b5bba585'+W,
 8:z+'16_bezhevyi_a45d8b32-eb86-4f9b-b91e-df88c554b68b'+W,9:z+'17_slonovakistka_9d4b59bf-7e75-468f-8ac3-13dd920e26e5'+W,
 10:z+'18_bordovyi_7b69a388-5430-4804-a718-dd1926f2c868'+W,11:z+'09_fioletovyi_49770504-2e4b-49d4-ae87-3062970c0377'+W,
 12:z+'13_rozovyi_f82350cc-7afd-4588-a057-e59734e0169e'+W,13:z+'07_zelenyi_bb16134f-914d-4345-841d-1323b002b269'+W,
 14:z+'05_zhovtyi_630d6278-d651-42c9-8dd0-59e541017a74'+W,15:z+'06_oranzhevyi_6c97a42b-0af2-4a00-82f6-071bd6449680'+W,
 16:z+'15_bilyi_c7c561be-e9e5-4a17-aebb-caf0e9c18aa4'+W,17:z+'10_holubyi_aa0333a1-feb9-4907-a7f7-423fa65055fa'+W,
 18:z+'19_biryuzovyi'+W};

/* —— СОТА: сіра —— */
var q='AUTAVEX-osnova-sira-sota_kant-',V='.jpg?v=1786209167';
S['1|1']={0:q+'02_chornyi_56c17228-386f-4704-9423-5ce368e530d9'+V,1:q+'03_svitlosiryi_deadff31-1cac-43a2-8c51-18cb3474ef50'+V,
 2:q+'04_siryi_a61a7cac-5b0c-41f5-a502-75fc4add7a8a'+V,3:q+'01_chervonyi_37abf19a-ff95-4cf5-a177-6287754bae4c'+V,
 4:q+'11_syniy_9ed9f378-5459-4d48-9226-62f27a94c4ba'+V,5:q+'12_temnosyniy_61acb268-3315-445a-adb6-0a545ac64f82'+V,
 6:q+'08_khaki_544eae38-1edc-47ac-a856-59697e10cf01'+V,7:q+'14_korychnevyi_2488ab7b-d44f-4e5c-bde2-d3806ef47d82'+V,
 8:q+'16_bezhevyi_f7298fc0-96f5-4886-aab8-f1f2b4011223'+V,9:q+'17_slonovakistka_725facbf-ed31-49f0-87e6-2e333df8d77d'+V,
 10:q+'18_bordovyi_84e29246-235a-48d2-a1d1-8e57b1438bfc'+V,11:q+'09_fioletovyi_579a1c0b-974e-4c86-b8d1-18e2d56283a9'+V,
 12:q+'13_rozovyi_c2b3913a-d77f-43e7-a7fc-47bb011bce70'+V,13:q+'07_zelenyi_8d184109-71b8-490b-943d-d76f9574a4fe'+V,
 14:q+'05_zhovtyi_81003da4-c49f-483c-af47-98c84389c37e'+V,15:q+'06_oranzhevyi_43d023ac-dfdd-4b35-9c8a-3f8dc337cf79'+V,
 16:q+'15_bilyi_a7b5a352-f196-4274-9231-3c0f288e6bc7'+V,17:q+'10_holubyi_ba9b7eb4-4939-4034-ac0d-c984da15c3bc'+V,
 18:q+'19_biryuzovyi'+V};

/* —— КРАПЛЯ: чорна (файли названі chorna-sota-teal) —— */
var t='AUTAVEX-osnova-chorna-sota-teal_kant-',U='.jpg?v=1786209743';
S['2|0']={
 0:t+'02_chornyi'+U,
 1:t+'03_svitlosiryi'+U,
 2:t+'04_siryi'+U,
 3:t+'01_chervonyi'+U,
 5:t+'12_temnosyniy'+U,
 6:t+'08_khaki'+U,
 7:t+'14_korychnevyi'+U,
 8:t+'16_bezhevyi'+U,
 9:t+'17_slonovakistka'+U,
 10:t+'18_bordovyi'+U,
 12:t+'13_rozovyi'+U,
 17:t+'10_holubyi'+U
};
})();
